/**
 * /dashboard has no page of its own and forwards to the projects list.
 *
 * FlatRoutes turns every route into a prefix match, so a plain <Navigate> here
 * also swallows everything below it — /dashboard/<id>/test-case-generation,
 * which the sidebar links to, silently lands on /projects instead of failing.
 * Only the bare path redirects; anything deeper falls through to the app's
 * not-found page until a route claims it.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '@backstage/core-plugin-api';

export function DashboardRedirect() {
  const { pathname } = useLocation();
  const { NotFoundErrorPage } = useApp().getComponents();

  if (pathname === '/dashboard' || pathname === '/dashboard/') {
    return <Navigate to="/projects" replace />;
  }
  return <NotFoundErrorPage />;
}
